import React, { Component } from 'react';
import { Button, Modal, Form } from 'semantic-ui-react';

class UserDetailsModal extends Component {
  state = {
    name: '',
    email: '',
    nameOk: true,
    emailOk: true,
    buttonDisabled: true,
  }

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value }, this.validate);
  }

  validate = () => {
    const {
      name,
      email,
    } = this.state;

    const emailRegExp = /(.+)@(.+)/;

    const nameOk = (name.length > 1);
    const emailOk = (email.length > 5) && email.match(emailRegExp);

    const buttonDisabled = !(nameOk && emailOk);
    this.setState({
      nameOk,
      emailOk,
      buttonDisabled,
    });
  }

  handleSuccess = () => {
    const {
      name,
      email,
    } = this.state;

    const { successHandler } = this.props;
    successHandler({ name, email });
  }

  render() {
    const {
      name,
      email,
      nameOk,
      emailOk,
      buttonDisabled,
    } = this.state;

    const { open, resourceType } = this.props;

    return (
      <div>

        <Modal
          open={open}
          closeOnEscape={false}
          closeOnRootNodeClick={false}
          onClose={this.close}
          size="tiny"
        >
          <Modal.Header>
            <h4 style={{ textAlign: 'center' }}>Hi! To access this {resourceType || 'report'} please confirm your details below.</h4>
          </Modal.Header>
          <Modal.Content >
            <Form fluid>
              <Form.Group widths="equal">
                <Form.Input error={!nameOk} placeholder="Name" name="name" value={name} onChange={this.handleChange} />
                <Form.Input error={!emailOk} placeholder="Email" name="email" value={email} onChange={this.handleChange} />
              </Form.Group>
            </Form>


          </Modal.Content>
          <Modal.Actions style={{ textAlign: 'center' }}>
            <Button
              centered
              disabled={buttonDisabled}
              basic
              style={{ width: 300 }}
              color="pink"
              size="large"
              content={`open the ${resourceType || 'report'}`}
              onClick={this.handleSuccess}
            />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default UserDetailsModal;



// WEBPACK FOOTER //
// ./src/components/user-details-modal/index.js